import React, { useState, useEffect } from "react";
import {
    Accordion, AccordionSummary, AccordionDetails,
    Typography, Grid, Box, TextField, IconButton, CircularProgress
} from "@mui/material";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import VolumeUpIcon from "@mui/icons-material/VolumeUp";
import NakdanButton from "../../SharedArea/NakdanButton";

import { observer } from "mobx-react-lite";
import additionalInfo from "../../../Mobx/AdditionalInfo";
import audio from "../../../Utils/audioPlayer";

const ExistsTrnsRuSection = observer(() => {
    const existsInfo = additionalInfo.existsInfo;
    const expanded = additionalInfo.expandedState;
    const loading = additionalInfo.loading;

    const [editedTrnsRu, setEditedTrnsRu] = useState({});

    useEffect(() => {
        if (existsInfo?.trnsRu) {
            setEditedTrnsRu(
                existsInfo.trnsRu.reduce((acc, trns_ru) => {
                    acc[trns_ru._id] = trns_ru.text;
                    return acc;
                }, {})
            );
        }
    }, [existsInfo]);

    const handleToggle = () => {
        additionalInfo.setExpandedState({ ...expanded, trnsRu: !expanded.trnsRu });
    };

    const isHebrew = (text) => /^[\u0590-\u05FF]/.test(text.trim());
    const playAudioFile = (fileName) => {
        const src = `https://lexillon-files-il.s3.il-central-1.amazonaws.com/files/audio/additional-info/${fileName}`;
        audio.pause();
        audio.src = src;
        audio.play();
    };

    return (
        <Grid item xs={12}>
            <Accordion
                expanded={expanded.trnsRu}
                onChange={() => handleToggle("trnsRu")}
                sx={{ boxShadow: 3, borderRadius: 2, width: "100%" }}
            >
                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                    <Typography variant="h6">({existsInfo.trnsRu?.length || 0}) תרגום לרוסית</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Box sx={{ width: "100%", textAlign: "center" }}>
                        {existsInfo.trnsRu?.length > 0 ? (
                            existsInfo.trnsRu.map((trns_ru) => {
                                const text = editedTrnsRu[trns_ru._id] || "";
                                const lang = isHebrew(text) ? "heIL" : "enUS";
                                const audioData = trns_ru.audio?.[lang] || {};
                                const maleFile = audioData.male;
                                const femaleFile = audioData.female;

                                return (
                                    <Box
                                        key={trns_ru._id}
                                        sx={{
                                            display: "flex",
                                            flexDirection: "column",
                                            alignItems: "center",
                                            justifyContent: "space-between",
                                            bgcolor: "#f0f0f0",
                                            p: 1,
                                            pt: 0,
                                            borderRadius: 2,
                                            mt: 0.5
                                        }}
                                    >
                                        <Box sx={{ display: "flex", gap: 0.5, ml: 1 }}>
                                            {/* כפתורי אודיו */}
                                            <IconButton
                                                onClick={() => maleFile && playAudioFile(maleFile)}
                                                disabled={!maleFile}
                                            >
                                                <VolumeUpIcon titleAccess="איש" />
                                            </IconButton>
                                            <IconButton
                                                onClick={() => femaleFile && playAudioFile(femaleFile)}
                                                disabled={!femaleFile}
                                            >
                                                <VolumeUpIcon titleAccess="אשה" />
                                            </IconButton>

                                            {/* כפתור ניקוד */}
                                            <NakdanButton
                                                text={text}
                                                onNikudComplete={(nikudText) => {
                                                    setEditedTrnsRu(prev => ({
                                                        ...prev,
                                                        [trns_ru._id]: nikudText,
                                                    }));
                                                }}
                                            />

                                            {/* שמירה / מחיקה */}
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.updateExistsInfo(
                                                        existsInfo._id,
                                                        "trnsRu",
                                                        trns_ru._id,
                                                        { text: editedTrnsRu[trns_ru._id] }
                                                    )
                                                }
                                                disabled={loading.updateExistsInfo.trnsRu?.[trns_ru._id] === "text"}
                                            >
                                                {loading.updateExistsInfo.trnsRu?.[trns_ru._id] === "text"
                                                    ? <CircularProgress size={24} />
                                                    : <SaveIcon color="primary" />}
                                            </IconButton>
                                            <IconButton
                                                onClick={() =>
                                                    additionalInfo.deleteExistsInfo(
                                                        existsInfo._id,
                                                        "trnsRu",
                                                        trns_ru._id
                                                    )
                                                }
                                                disabled={loading.deleteExistsInfo.trnsRu?.[trns_ru._id]}
                                            >
                                                {loading.deleteExistsInfo.trnsRu?.[trns_ru._id]
                                                    ? <CircularProgress size={24} />
                                                    : <DeleteIcon color="error" />}
                                            </IconButton>
                                        </Box>

                                        <TextField
                                            fullWidth
                                            variant="outlined"
                                            size="small"
                                            multiline
                                            minRows={1}
                                            value={text}
                                            onChange={(e) =>
                                                setEditedTrnsRu({
                                                    ...editedTrnsRu,
                                                    [trns_ru._id]: e.target.value,
                                                })
                                            }
                                            sx={{
                                                direction: isHebrew(text) ? "ltr" : "rtl"
                                            }}
                                        />
                                    </Box>
                                );
                            })
                        ) : (
                            <Typography variant="body2" color="textSecondary">אין תרגומים לרוסית זמינים</Typography>
                        )}
                    </Box>
                </AccordionDetails>
            </Accordion>
        </Grid>
    );
});

export default ExistsTrnsRuSection;
